import { Injectable } from '@angular/core';
import { I18NextService } from 'angular-i18next';

@Injectable()
export class I18nTranslateService extends I18NextService {
  constructor(errorHandlingStrategy) {
    super(errorHandlingStrategy);
  }
}
